import { mapGetters } from 'vuex'
import { dateToShow } from '@/helpers/dates'

export default {
  ...mapGetters('app/patient/agendas', [
    'filters'
  ]),
  getDay () {
    return dateToShow(this.agenda.next_schedule)
  },
  bc () {
    return this.background || (this.dark ? 'rgba(0,0,0,0.8)' : 'rgba(255,255,255,0.8)')
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/components/schedule/resources/computed.js